import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SeismicCrewDto } from '@cradua/data';
import Swal from 'sweetalert2';
@Component({
  selector: 'cradua-seismic-crew',
  templateUrl: './seismic-crew.component.html',
  styleUrls: ['./seismic-crew.component.scss']
})
export class SeismicCrewComponent implements OnInit {

  
  seismiccrewForm: FormGroup;
  seismiccrewFormArray: FormGroup;
  control = new FormControl();
  @Input() seismiccrews: SeismicCrewDto[];
  @Input() routeAnimationsElements: any;
  @Output() seismiccrew = new EventEmitter<SeismicCrewDto[]>()
  @Output() deleteSeismicCrewEvent = new EventEmitter<any>()

    selectedSeismicCrew: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnInit() {
      this.createSeismicCrewForm();
    }

    createSeismicCrewForm() {
      this.seismiccrewForm = this.fb.group({
        CrewName: ['', Validators.required],
        id: null
        });
        this.seismiccrewFormArray = this.fb.group({ SeismicCrews: this.fb.array([])
          });
        this.setSeismicCrew();
    }

  // method to display seismiccrews
  setSeismicCrew() {
    const control  = this.seismiccrewFormArray.controls.SeismicCrews as FormArray;
    this.seismiccrews.forEach( e => {
      control.push(
        this.fb.group({
        CrewName: e.CrewName,
          id: e.id
        })
      );
    });
  }


  // method to add SeismicCrew
  addSeismicCrew(value: SeismicCrewDto) {
    const control  = this.seismiccrewFormArray.controls.SeismicCrews as FormArray;
    control.insert(0,
          this.fb.group({
           CrewName: value.CrewName,
            id: null
          })
       );
  }

  selectSeismicCrew(value) {}

  // method to delete seismiccrew from arrary list
  deleteSeismicCrew(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.seismiccrewFormArray.controls.SeismicCrews as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.seismiccrews.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.seismiccrews[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: SeismicCrewDto) {
    if(this.seismiccrewForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.seismiccrewFormArray.get('SeismicCrews')['controls'][this.selectedIndex].patchValue({CrewName: formValue.CrewName});
    } else {
      this.addSeismicCrew(formValue);
    }
    this.selectedIndex = null;
    this.seismiccrewForm.reset()
  }

  onEdit(index, value: SeismicCrewDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.seismiccrewForm.patchValue({CrewName: value.CrewName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.seismiccrewForm.reset();
  }

  onSubmit(formValue: SeismicCrewDto[]) {
  this.seismiccrew.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteSeismicCrewEvent.emit(this.filteredDelete);
  }
  }

}

